function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Logo 5",
    clipPath: "url(#clip0_322_33)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M51 0C58.732 0 65 6.268 65 14V51C65 58.732 58.732 65 51 65H14C6.268 65 0 58.732 0 51V14C0 6.268 6.268 0 14 0H51ZM51 2H14C7.475 2 2.166 7.209 2.004 13.695L2 14V51C2 57.525 7.209 62.834 13.695 62.996L14 63H51C57.525 63 62.834 57.791 62.996 51.305L63 51V14C63 7.475 57.791 2.166 51.305 2.004L51 2Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.082 20.9072H17.4925V34.7532C17.4925 46.2964 23.8398 50.2899 32.4972 50.2899C41.1036 50.2899 47.5092 46.2454 47.5092 34.7532V20.9072H50.9197V14.7129H36.4907V20.9072H39.9012V34.7532C39.9012 41.6325 36.9571 43.7822 32.5555 43.7822C28.0957 43.7822 25.1006 41.6325 25.1006 34.7532V20.9072H28.511V14.7129H14.082V20.9072Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_322_33"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 65,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.d6640552edaa5da96b34bfa08a45a8ff.svg";
export { ForwardRef as ReactComponent };